export default {
    en: {
        amount_receive: 'Amount receive',
        currency_receive: 'Amount and currency receive',
        currency_send: 'Amount and currency send',
        sender: 'Sender',
        sender_bank: 'Sender`s bank',
        sender_bank_choose: 'Choose sender`s bank',
        may_comissions: 'Interbank commissions are possible',
        add_comment: 'Add comment',
        hide_comment: 'Hide comment',
        description: 'Description',
        description_placeholder: 'Describe the purpose of the bill',
        btn_pay: 'To pay',
        btn_auth: 'Authorize',
        btn_reg: 'Register',
        error_title: 'Error',
        critical_error: 'Critical error',
    },
    ru: {
        amount_receive: 'Сумма получения',
        currency_receive: 'Сумма и валюта получения',
        currency_send: 'Сумма и валюта отправления',
        sender: 'Отправитель',
        sender_bank: 'Банк отправителя',
        sender_bank_choose: 'Выберите банк отправителя',
        may_comissions: 'Возможны межбанковские комиссии',
        add_comment: 'Добавить комментарий',
        hide_comment: 'Скрыть комментарий', 
        description: 'Описание',
        description_placeholder: 'Опишите назначение счета',
        btn_pay: 'К оплате',
        btn_auth: 'Авторизация',
        btn_reg: 'Регистрация',
        error_title: 'Ошибка',
        critical_error: 'Критическая ошибка',
    }
}